export class AuthModel {
  token: string | undefined;
  refreshtoken: string | undefined;
  expiresIn: Date | undefined;

  setAuth(auth: AuthModel) {
    this.token = auth.token;
    this.refreshtoken = auth.refreshtoken;
    this.expiresIn = auth.expiresIn;
  }
}
export class AuthModelUser {
  token: string | undefined;
  refreshToken: string | undefined;
  expiresIn: Date | undefined;
  userEmail: string | undefined;

  setAuth(auth: AuthModelUser) {
    this.token = auth.token;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
    this.userEmail = auth.userEmail;
  }
}
export class AuthLoginModel {
  token: string | undefined;
  refreshToken: string | undefined;
  expiresIn: Date | undefined;
  PhoneNumber: string | undefined;

  setAuth(auth: AuthLoginModel) {
    this.token = auth.token;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
    this.PhoneNumber = auth.PhoneNumber;
  }
}
export class User {
  email: string | undefined;
  emailConfirmed: boolean | undefined
  expires: number | undefined
  firstName: string | undefined
  isSuccess: boolean | undefined
  lastName: string | undefined
  phoneNumber: string | undefined
  phoneNumberConfirmed: boolean | undefined
  refreshToken: string | undefined
  token: string | undefined
  userName: string | undefined
  verifyChoice: string | undefined
  expiresIn: Date | undefined

  SetUser(data: any) {
    this.email = data.email
    this.emailConfirmed = data.emailConfirmed === '1'
    this.expires = data.expires
    this.firstName = data.firstName
    this.isSuccess = data.isSuccess
    this.lastName = data.lastName
    this.phoneNumber = data.phoneNumber
    this.phoneNumberConfirmed = data.phoneNumberConfirmed
    this.refreshToken = data.refreshToken
    this.token = data.token
    this.userName = data.userName
    this.verifyChoice = data.verifyChoice
    this.expires = data.expires
  }
}
export interface validatetok {
  Token: string
  RememberUser: boolean,
}
export interface validatecode {
  RememberUser: boolean,
  Token: string
}
export interface emailtok {
  Token: string
  email: string
  newPassword?: string
  confirmPassword?: string
}
export interface changepasswordtok {
  Password: string
  ConfirmPassword: string
  OldPassword: string
}
export interface validateretry {
  RememberUser: boolean
}
export interface validateemailval {
  email: string
  RememberUser: boolean
}